import { createTheme } from '@mui/material/styles';
import { red } from '@mui/material/colors';

// MS theme
declare module '@mui/material/styles' {
  interface TypographyVariants {
    sample_calculation_label: React.CSSProperties;
    custom_banner_font: React.CSSProperties;
  }
  interface TypographyVariantsOptions {
    sample_calculation_label: React.CSSProperties;
    custom_banner_font: React.CSSProperties;
  }
}
const theme = createTheme({
  palette: {
    primary: {
      main: '#002B51',
    },
    secondary: {
      main: '#0F8EC7',
    },
    error: {
      main: red.A400,
    },
  },
  typography: {
    fontFamily: 'inherit',
    sample_calculation_label: {
      fontSize: '1.25rem',
    },
    custom_banner_font: {
      fontSize: 14,
    },
  },
});

export default theme;
